import React, { Component } from "react";
import { Row, Col, Divider, Tooltip } from "antd";
import moment from "moment";
import PropTypes from "prop-types";
import MobileExpanded from "./Components/MobileExpanded/MobileExpanded";
import {
  SecondaryButtonComponent,
  DataHeading,
  DataValue,
  JustifyBetween,
  SemiDarkerDivider,
  MobileViewWrapper
} from "../../../../CommonComponents/commonStyles";
import { renderAmountGrid } from "../../../../utils/ValueFormatter";
import {
  formatShares,
  initiateTracking,
  recordError
} from "../../../../utils/commonUtil";
import { MobileCard, InvestmentOption, UnderlyingContent } from "./styles";
import upCaret from "../../../../assets/icons/short-arrow-t.svg";
import downCaret from "../../../../assets/icons/short-arrow-b.svg";
import { CapsuleButton } from "../../../../CommonComponents/Commons/commonComponents";
import { replaceSelect } from "../../../../utils/replacer";

export class InvestmentOptionDetailsMobile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentItemId: undefined,
      accountType: this.props.accountType
    };
    this.showMoreBtnTitle = "Show More";
  }

  componentDidMount() {
    this.setState({ accountType: this.props.accountType });
  }

  componentWillReceiveProps(np) {
    this.setState({ accountType: np.accountType });
    if (np.itemData) {
      const params = this.props.location.state;
      const poolName =
        params && params.hasOwnProperty("poolName") ? params.poolName : "";
      let poolIndex = -1;

      if (poolName && np.itemData)
        poolIndex = np.itemData.findIndex(i => i.investmentOption === poolName);

      if (poolIndex > -1) this.setState({ currentItemId: poolIndex });
    }
  }

  clickHandler = key => {
    try {
      const { activeKey, itemData } = this.props;
      let tabName = "";
      switch (activeKey) {
        case "1":
          tabName = "My Investments";
          break;
        case "2":
          tabName = "Portfolio Solutions";
          break;
        case "3":
          tabName = "Portfolio Builders";
          break;
        default:
          tabName = "Values-driven Investments";
          break;
      }
      let selectedName = itemData[key].investmentOption;
      initiateTracking(
        "showMore",
        this.props.getPageTitle(),
        tabName,
        `${this.showMoreBtnTitle} - ${selectedName}`
      );
          
      const currentItemId = key !== this.state.currentItemId ? key : undefined;      
      this.setState({ currentItemId });
      return tabName;
    } catch (error) {      
      recordError(error);
    }
  };

  render() {
    switch (this.props.tabIndex) {
      case 0:
        return (
          <>
            {this.props.itemData &&
              this.props.itemData.map((item, index) => {
                return (
                  <MobileCard
                    data-test="Mobilecard-TestCase0"
                    key={index}
                    cardIndex={index}
                    activeCard={this.state.currentItemId === index ? true : false}
                    className="mobileCard"
                  >
                    <InvestmentOption>{replaceSelect(item.investmentOption)}</InvestmentOption>
                    <Row>
                      <Col xs={13}>
                        <DataHeading>Current Balance</DataHeading>
                        <DataValue>
                          {renderAmountGrid(item.currentBalance)}
                        </DataValue>
                      </Col>
                      <Col xs={11}>
                        <DataHeading>Available units</DataHeading>
                        <DataValue>
                          {formatShares(item.availableUnits)}
                        </DataValue>
                      </Col>
                    </Row>
                    <Divider className="my2" />
                    <Row>
                      <Col xs={13}>
                        <DataHeading>
                          Expense ratios
                        </DataHeading>
                        <DataValue>
                          {item.selExpRatio === "" ? (
                            <> &mdash; </>
                          ) : (
                            <> {item.selExpRatio}% </>
                          )}
                        </DataValue>
                      </Col>
                      <Col xs={11}>
                        <DataHeading>
                          Current NAV
                        </DataHeading>

                        <DataValue>
                          <Tooltip
                            placement="bottom"
                            title={moment(item.date).format("LL")}
                          >
                            <UnderlyingContent id={"anrNavigation" + index}>
                              {renderAmountGrid(item.currentNAV)}
                            </UnderlyingContent>
                          </Tooltip>
                        </DataValue>
                      </Col>
                    </Row>
                    <Divider className="my2" />
                    {this.state.currentItemId === index ? (
                      <MobileExpanded
                        data={item}
                        tabIndex={this.props.tabIndex}
                        accountType={this.state.accountType}
                      />
                    ) : null}
                  </MobileCard>
                );
              })}
            <SemiDarkerDivider />
          </>
        );
      case 1:
        return (
          <>
            {this.props.itemData &&
              this.props.itemData.map((item, index) => (
                <MobileCard
                  data-test="Mobilecard-TestCase1"
                  key={index}
                  cardIndex={index}
                  activeCard={this.state.currentItemId === index ? true : false}
                  className="mobileCard"
                >
                  <MobileViewWrapper data-test={`caseoneWrapper${index}`} onClick={() => {
                    this.clickHandler(index);
                  }}>
                    <InvestmentOption>{replaceSelect(item.investmentOption)}</InvestmentOption>
                    <JustifyBetween>
                      <div>
                        <DataHeading>Returns Qtr</DataHeading>
                        <DataValue>{item.returnsYTD}%</DataValue>
                      </div>
                      <div>
                        <DataHeading>1 year</DataHeading>
                        <DataValue>{item.oneY}%</DataValue>
                      </div>
                      <div>
                        <DataHeading>5 year</DataHeading>
                        <DataValue>{item.fiveY}%</DataValue>
                      </div>
                      <div>
                        <DataHeading>10 year</DataHeading>
                        <DataValue>{item.tenY}%</DataValue>
                      </div>
                    </JustifyBetween>
                    <Divider className="my2" />
                    <Row>
                      {/* Will be needed for future
                      <Col xs={12}>
                        <DataHeading>
                          Expense ratios <br />(Standard)
                      </DataHeading>
                        <DataValue>
                          {item.stdExpRatio === "" ? (
                            <> &mdash; </>
                          ) : (
                              <> {item.stdExpRatio}% </>
                            )}
                        </DataValue>
                      </Col> */}
                      <Col xs={12}>
                        <DataHeading>
                          Expense ratios
                      </DataHeading>
                        <DataValue>
                          {item.selExpRatio === "" ? (
                            <> &mdash; </>
                          ) : (
                              <> {item.selExpRatio}% </>
                            )}
                        </DataValue>
                      </Col>
                    
                      <JustifyBetween>
                        <div>
                          <DataHeading>
                            Current NAV
                        </DataHeading>
                          <DataValue>
                            {item.currentNAV === "" ? (
                              <> &mdash; </>
                            ) : (
                              <>
                                <Tooltip
                                  placement="bottom"
                                  title={moment(item.date).format("LL")}
                                >
                                  <UnderlyingContent>
                                    {renderAmountGrid(item.currentNAV)}
                                  </UnderlyingContent>
                                </Tooltip>
                              </>
                            )}
                          </DataValue>
                        </div>
                      </JustifyBetween>
                    </Row>
                  </MobileViewWrapper>
                  <Divider className="my2" />
                  {this.state.currentItemId === index ? (
                    <MobileExpanded
                      data={item}
                      tabIndex={this.props.tabIndex}
                      accountType={this.state.accountType}
                    />
                  ) : null}
                  {this.state.currentItemId === index ? (
                    <CapsuleButton
                      data-test={`showLessCase1${index}`}
                      text="Show Less"
                      iconType="arrowUp"
                      whiteBackground
                      styles="w50"
                      onClick={() => {
                        this.clickHandler(index);
                      }}
                    />
                  ) : (
                    <CapsuleButton
                      data-test={`showLessCase1${index}`}
                      text={this.showMoreBtnTitle}
                      iconType="arrowDown"
                      whiteBackground
                      styles="w50"
                      onClick={() => {
                        this.clickHandler(index);
                      }}
                    />
                  )}
                </MobileCard>
              ))}
            <SemiDarkerDivider />
          </>
        );
      case 2:
        return (
          <>
            {this.props.itemData &&
              this.props.itemData.map((item, index) => {
                return (
                  <MobileCard
                    data-test="Mobilecard-TestCase2"
                    key={index}
                    cardIndex={index}
                    activeCard={
                      this.state.currentItemId === index ? true : false
                    }
                    className="mobileCard"
                  >
                    <MobileViewWrapper
                      data-test={`casetwoWrapper${index}`}
                      onClick={() => {
                        this.clickHandler(index);
                      }}
                    >
                      <InvestmentOption>
                        {replaceSelect(item.investmentOption)}
                      </InvestmentOption>
                      <JustifyBetween>
                        <div>
                          <DataHeading>Returns Qtr</DataHeading>
                          <DataValue>
                            {item.returnsYTD === "" ? (
                              <> &mdash; </>
                            ) : (
                              <> {item.returnsYTD}% </>
                            )}
                          </DataValue>
                        </div>
                        <div>
                          <DataHeading>1 year</DataHeading>
                          <DataValue>
                            {item.oneY === "" ? (
                              <> &mdash; </>
                            ) : (
                              <> {item.oneY}% </>
                            )}
                          </DataValue>
                        </div>
                        <div>
                          <DataHeading>5 year</DataHeading>
                          <DataValue>
                            {item.fiveY === "" ? (
                              <> &mdash; </>
                            ) : (
                              <> {item.fiveY}% </>
                            )}
                          </DataValue>
                        </div>
                        <div>
                          <DataHeading>10 year</DataHeading>
                          <DataValue>
                            {item.tenY === "" ? (
                              <> &mdash; </>
                            ) : (
                              <> {item.tenY}% </>
                            )}
                          </DataValue>
                        </div>
                      </JustifyBetween>
                      <Divider className="my2" />
                      <Row>
                        {/* Will be needed for future
                        <Col xs={12}>
                          <DataHeading>
                            Expense ratios <br />(Standard)
                      </DataHeading>
                          <DataValue>
                            {item.stdExpRatio === "" ? (
                              <> &mdash; </>
                            ) : (
                              <> {item.stdExpRatio}% </>
                            )}
                          </DataValue>
                        </Col> */}
                        <Col xs={12}>
                          <DataHeading>
                            Expense ratios
                      </DataHeading>
                          <DataValue>
                            {item.selExpRatio === "" ? (
                              <> &mdash; </>
                            ) : (
                              <> {item.selExpRatio}% </>
                            )}
                          </DataValue>
                        </Col>
                      
                        <JustifyBetween>
                          <div>
                            <DataHeading>
                              Current NAV
                        </DataHeading>
                            <DataValue>
                              {item.currentNAV === "" ? (
                                <> &mdash; </>
                              ) : (
                                <>
                                  {" "}
                                  <Tooltip
                                    placement="bottom"
                                    title={moment(item.date).format("LL")}
                                  >
                                    <UnderlyingContent>
                                      {renderAmountGrid(item.currentNAV)}
                                    </UnderlyingContent>
                                  </Tooltip>
                                </>
                              )}
                            </DataValue>
                          </div>
                        </JustifyBetween>
                      </Row>
                    </MobileViewWrapper>
                    <Divider className="my2" />
                    {this.state.currentItemId === index ? (
                      <MobileExpanded
                        data={item}
                        tabIndex={this.props.tabIndex}
                        accountType={this.state.accountType}
                      />
                    ) : null}
                    {this.state.currentItemId === index ? (
                      <SecondaryButtonComponent
                        data-test={`showLessCase2${index}`}
                        id={"btnShowLess" + index}
                        onClick={() => {
                          this.clickHandler(index);
                        }}
                        className="mt2 w50"
                      >
                        <img src={upCaret} className="mr1" alt="UpCaret" /> Show
                        Less
                      </SecondaryButtonComponent>
                    ) : (
                      <SecondaryButtonComponent
                        data-test={`showLessCase2${index}`}
                        id={"btnDownCaret" + index}
                        onClick={() => {
                          this.clickHandler(index);
                        }}
                        className="mt2 w50 btn-show-more-mobile"
                      >
                        <img src={downCaret} className="mr1" alt="DownCaret" />{" "}
                        {this.showMoreBtnTitle}
                      </SecondaryButtonComponent>
                    )}
                  </MobileCard>
                );
              })}
            <SemiDarkerDivider />
          </>
        );
      case 3:
        return (
          <>
            {this.props.itemData &&
              this.props.itemData.map((item, index) => (
                <MobileCard
                  data-test="Mobilecard-TestCase3"
                  key={index}
                  cardIndex={index}
                  activeCard={this.state.currentItemId === index ? true : false}
                  className="mobileCard"
                >
                  <MobileViewWrapper
                    data-test={`casethreeWrapper${index}`}
                    onClick={() => {
                      this.clickHandler(index);
                    }}
                  >
                    <InvestmentOption>{replaceSelect(item.investmentOption)}</InvestmentOption>
                    <JustifyBetween>
                      <div>
                        <DataHeading>Returns Qtr</DataHeading>
                        <DataValue>
                          {item.returnsYTD === "" ? (
                            <> &mdash; </>
                          ) : (
                            <> {item.returnsYTD}% </>
                          )}
                        </DataValue>
                      </div>
                      <div>
                        <DataHeading>1 year</DataHeading>
                        <DataValue>
                          {item.oneY === "" ? (
                            <> &mdash; </>
                          ) : (
                            <> {item.oneY}% </>
                          )}
                        </DataValue>
                      </div>
                      <div>
                        <DataHeading>5 year</DataHeading>
                        <DataValue>
                          {item.fiveY === "" ? (
                            <> &mdash; </>
                          ) : (
                            <> {item.fiveY}% </>
                          )}
                        </DataValue>
                      </div>
                      <div>
                        <DataHeading>10 year</DataHeading>
                        <DataValue>
                          {item.tenY === "" ? (
                            <> &mdash; </>
                          ) : (
                            <> {item.tenY}% </>
                          )}
                        </DataValue>
                      </div>
                    </JustifyBetween>
                    <Divider className="my2" />
                    <Row>
                      {/* Will be needed for future
                      <Col xs={12}>
                        <DataHeading>
                          Expense ratios <br />(Standard)
                      </DataHeading>
                        <DataValue>
                          {item.stdExpRatio === "" ? (
                            <> &mdash; </>
                          ) : (
                            <> {item.stdExpRatio}% </>
                          )}
                        </DataValue>
                      </Col> */}
                      <Col xs={12}>
                        <DataHeading>
                          Expense ratios
                      </DataHeading>
                        <DataValue>
                          {item.selExpRatio === "" ? (
                            <> &mdash; </>
                          ) : (
                              <> {item.selExpRatio}% </>
                            )}
                        </DataValue>
                      </Col>
                      <JustifyBetween>
                        <div>
                          <DataHeading>
                            Current NAV
                        </DataHeading>
                          <DataValue>
                            {item.currentNAV === "" ? (
                              <> &mdash; </>
                            ) : (
                              <>
                                <Tooltip
                                  placement="bottom"
                                  title={moment(item.date).format("LL")}
                                >
                                  <UnderlyingContent id={"anrNavigation" + index}>
                                    {renderAmountGrid(item.currentNAV)}
                                  </UnderlyingContent>
                                </Tooltip>
                              </>
                            )}
                          </DataValue>
                        </div>
                      </JustifyBetween>
                    </Row>
                  </MobileViewWrapper>
                  <Divider className="my2" />
                  {this.state.currentItemId === index ? (
                    <MobileExpanded
                      data={item}
                      tabIndex={this.props.tabIndex}
                      accountType={this.state.accountType}
                    />
                  ) : null}
                  {this.state.currentItemId === index ? (
                    <SecondaryButtonComponent
                      data-test={`showLessCase3${index}`}
                      id={"btnShowLessMobile" + index}
                      onClick={() => {
                        this.clickHandler(index);
                      }}
                      className="mt2 w50 btn-show-more-mobile"
                    >
                      <img src={upCaret} className="mr1" alt="UpCaret" /> Show
                      Less
                    </SecondaryButtonComponent>
                  ) : (
                    <SecondaryButtonComponent
                      data-test={`showLessCase3${index}`}
                      id={"btnDownCaretMobile" + index}
                      onClick={() => {
                        this.clickHandler(index);
                      }}
                      className="mt2 w50 btn-show-more-mobile"
                    >
                      <img src={downCaret} className="mr1" alt="DownCaret" />{" "}
                      {this.showMoreBtnTitle}
                    </SecondaryButtonComponent>
                  )}
                </MobileCard>
              ))}
            <SemiDarkerDivider />
          </>
        );
      default:
        return <>No data present</>;
    }
  }
}

InvestmentOptionDetailsMobile.propTypes = {
  accountType: PropTypes.string,
  activeKey: PropTypes.string,
  getPageTitle: PropTypes.func,
  itemData: PropTypes.array,
  tabIndex: PropTypes.number
};

export default InvestmentOptionDetailsMobile;
